<template>
  <div id="py">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'py'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/personal/remark/Remark.vue